import React from 'react';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function AuthHeader() {
  const { t } = useTranslation();
  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-16 px-6 flex items-center justify-between bg-background border-b border-border">
      <div className="flex items-center space-x-2">
        <Link to="/" aria-label={t('app.brand', { defaultValue: 'Mishu' })}>
          <img src="/mishu_svg.svg" alt={t('app.brand', { defaultValue: 'Mishu' })} className="h-8 w-auto" />
        </Link>
      </div>
      <div className="flex items-center space-x-4">
        <LanguageSwitcher />
      </div>
    </header>
  );
}
